export const memberSettingsPaths = {
  index: () => "/audience/manage",
  profileFieldList: () => "/members/profile_fields",
  profileFieldManage: () => "/members/profile_fields/manage",
};
